import type { Lead, SourceBucket } from '@/data/types';

export const BUCKET_LABEL: Record<SourceBucket, string> = {
  paid: 'Paid', organic: 'Organic', ai: 'AI assistant', referral: 'Referral', outbound: 'Outbound',
};
export const BUCKET_OPTIONS = (Object.keys(BUCKET_LABEL) as SourceBucket[]).map((value) => ({ value, label: BUCKET_LABEL[value] }));

/* The channel split plus the one detail that matters for it: the campaign for
   paid, the source name for manual leads, the assistant for AI traffic. */
export function SourceBadge({ lead }: { lead: Pick<Lead, 'sourceBucket' | 'campaignKey' | 'utmCampaign' | 'sourceLabel'> }) {
  const detail = lead.sourceLabel ?? lead.utmCampaign ?? null;
  return (
    <span className="crm-src">
      <span className={`crm-src__bucket crm-src__bucket--${lead.sourceBucket}`}>{BUCKET_LABEL[lead.sourceBucket]}</span>
      {detail && <span className="crm-src__detail" title={lead.campaignKey ?? undefined}>{detail}</span>}
    </span>
  );
}
